import { useQuery } from '@tanstack/react-query';

import { queryKeys } from '@/api/queryKeys';
import { useAuth } from '@/features/auth/hooks/useAuth';

import { fetchMyMenu } from '../api/navigationApi';

/**
 * The signed-in user's menu. The tree only changes when someone edits it or
 * the user's roles change, so it is held for five minutes rather than the
 * app-wide 30 s — every screen mounts the sidebar and the tab bar.
 */
export function useMenu() {
  const { user } = useAuth();
  return useQuery({
    queryKey: queryKeys.navigation.menu(user?.id ?? ''),
    queryFn: fetchMyMenu,
    enabled: Boolean(user),
    staleTime: 5 * 60_000,
  });
}
